import { render, staticRenderFns } from "./MothersDay_foodItem.vue?vue&type=template&id=ae5b5314&scoped=true"
import script from "./MothersDay_foodItem.vue?vue&type=script&lang=ts"
export * from "./MothersDay_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./MothersDay_foodItem.vue?vue&type=style&index=0&id=ae5b5314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5b5314",
  null
  
)

export default component.exports